import store from '@/store/index.js'
import { captureException } from '@/helpers/sentry'
import { provideEnvConfigOld } from 'shared/lk/helpers/env'

export function getCurrentEnv() {
    const defaultEnv = provideEnvConfigOld().env
    return window.localStorage.livekid_env || defaultEnv
}

/**
 * Determines whether the application is in development enviroment
 *
 * @returns True if is in development
 */
export const isDEV = () => {
    return process.env.NODE_ENV != 'production'
}
/**
 * Gets application type based on VUE_APP_ENV_NAME
 * from enviroment variables
 * @returns
 */
export const getAppType = () => {
    const envName = provideEnvConfigOld().env
    return envName && envName.includes('wekita') ? 'wekita' : 'livekid'
}
/**
 * Gets application name based on application type
 *
 * @returns Application name
 */
export const getAppName = () => {
    switch (getAppType()) {
        case 'wekita':
            return 'wekita-Welt'
        default:
            return 'LiveKid'
    }
}
/**
 * Gets logo path based on application type
 *
 * @returns Relative path in assets
 */
export const getAppLogo = () => {
    switch (getAppType()) {
        case 'wekita':
            return {
                logo: '/img/wekita_logo_long.png',
                signature: '/img/wekita_logo_long.png',
                signet: '/img/wekita_logo_short.png'
            }
        default:
            return {
                logo: '/img/logo.svg',
                signature: '/img/logo_signature.svg',
                signet: '/img/logo_signet.svg'
            }
    }
}
/**
 * Gets favicon path based on application type
 *
 * @returns Relative path in assets
 */
export const getAppFavicon = () => {
    switch (getAppType()) {
        case 'wekita':
            return '/img/favicon_wekita.png'
        default:
            return '/img/favicon.ico'
    }
}
/**
 * Sets favicon path in HTML tag.
 */
export const setAppFavicon = () => {
    const favicon = getAppFavicon()
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.getElementsByTagName('head')[0].appendChild(link)
    }
    link.href = favicon
}
/**
 * Sets application title
 */
export const setAppTitle = () => {
    document.title = getAppName()
}
/**
 * Gets main application URL based on current enviroment and application type
 * @returns
 */
export const getMainApp = () => {
    const env = getCurrentEnv()
    const appType = getAppType()

    switch (env) {
        case 'rc':
            return 'https://rc.app.livekid.pl/'
        case 'stage':
            return 'https://stage.app.livekid.pl/'
        default:
            switch (appType) {
                case 'wekita':
                    return 'https://app.wekita-welt.de/'
                default:
                    return 'https://app.livekid.com/'
            }
    }
}
/**
 * Opens window with regulations for given type of regulation and user's role.
 * If there is no document for given parameters, then window does not open and
 * exception is sent to Sentry
 *
 * @param type Type of regulation (terms of service or regulation)
 * @param role User's role (school/teacher/parent)
 * @returns
 */
export const getRegulations = (type, role) => {
    const { region } = store.state
    const regulations = {
        ch: `de-ch/allgemeine-geschaeftsbedingungen`,
        de: `de/allgemeine-geschaeftsbedingunge`,
        es: `es/terminos-y-condiciones/`,
        pl: `pl/regulamin`,
        wekita: `de/agb-wekita-welt`,
        school_pl: `pl/regulamin-dla-placowki/?_ga=2.25252414.203701643.1577949072-576133507.1560934293`,
        school_es: `es/terminos-y-condiciones-para-centros/`
    }
    const privacy = {
        ch: `de-ch/datenschutz`,
        de: `de/datenschutz`,
        es: `es/politica-de-privacidad/`,
        pl: `pl/polityka-prywatnosci/?_ga=2.63151276.203701643.1577949072-576133507.1560934293`,
        wekita: `de/datenschutz-wekita-welt`
    }
    const regulationsObject = { privacy, regulations }
    let objectRegion = getAppType() == 'wekita' ? 'wekita' : region
    if (role == 'school' && type == 'regulations')
        objectRegion = `school_${objectRegion}`
    const baseUrl = 'https://livekid.com/'
    const specificUrl = regulationsObject[type][objectRegion]
    if (!specificUrl) {
        captureException(
            'There is no document in SignUp form for specified parameters',
            '',
            {
                type,
                role,
                objectRegion
            }
        )
        return
    }
    window.open(baseUrl + specificUrl, '_blank')
}
